import { IconButton } from "@mui/material";
import React from "react";
import SpeechRecognition, {
    useSpeechRecognition,
} from "react-speech-recognition";
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import useUpdateEffect from "react-use/lib/useUpdateEffect";

interface Props {
    onTranscript: (text: string) => unknown;
}

const SpeechToTextButton = ({ onTranscript }: Props) => {
    const {
        transcript,
        listening,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    const startListening = React.useCallback(
        () =>
            SpeechRecognition.startListening({ continuous: true, language: "en-GB" }),
        []
    );
    const stopListening = React.useCallback(
        () =>
            SpeechRecognition.stopListening(),
        []
    );

    useUpdateEffect(() => {
        if (browserSupportsSpeechRecognition) {
            onTranscript(transcript);
        }
    }, [transcript, onTranscript]);

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }

    return (
        <IconButton
            color={listening ? "primary" : undefined}
            onClick={listening ? stopListening : startListening}
        >
            <KeyboardVoiceIcon />
        </IconButton>
    );
};

export default SpeechToTextButton;
